import { useTranslation } from "react-i18next";
import { DocsToc, ParamTable } from "../components";
import { DocsTocItem } from "../interfaces";
import { DOCS_GLOSSARY_GROUPS } from "../utils";

// YOSHI-10464: one entry of the index per subject, so the reader lands on the block of fields they
// are looking at instead of scrolling a single long table.
const TOC_ITEMS: DocsTocItem[] = DOCS_GLOSSARY_GROUPS.map((group) => {
  return {
    id: `glossary-${group.key}`,
    translationKey: `docs.glossary.groups.${group.key}.title`,
    level: 1,
  };
});

export const Glossary = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col-reverse gap-8 lg:flex-row lg:gap-12">
      <div className="min-w-0 flex-1 space-y-12">
        <div className="space-y-4">
          <h2 className="text-xl font-bold lg:text-2xl">
            {t("docs.glossary.title")}
          </h2>
          <p className="text-base/relaxed text-gray-400 lg:text-lg/relaxed">
            {t("docs.glossary.intro")}
          </p>
        </div>

        {DOCS_GLOSSARY_GROUPS.map((group) => (
          <div key={group.key} className="space-y-4">
            <h3
              id={`glossary-${group.key}`}
              className="scroll-mt-6 text-lg font-bold lg:text-xl"
            >
              {t(`docs.glossary.groups.${group.key}.title`)}
            </h3>
            <p className="text-base/relaxed text-gray-400 lg:text-lg/relaxed">
              {t(`docs.glossary.groups.${group.key}.content`)}
            </p>
            {/* The same table the parameters use, with the field name in place of the parameter
                name: the glossary is consulted next to the reference and must not read as a
                different document. */}
            <ParamTable rows={group.fields} nameLabelKey="field" />
          </div>
        ))}
      </div>
      <DocsToc items={TOC_ITEMS} />
    </div>
  );
};
